import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
    return (
        <div id="About" className="aboutUsContainer">
            
            <div className="teamMember">
                <img
                    className="memberPhoto"
                    src="https://andrewslearningimage-bucket.s3.amazonaws.com/media/Aboutus_image.jpeg"
                    alt="Andrew Browne"
                />
                <h2 className="memberName">Andrew Browne, B.Sc. (Biochemistry), PhD Candidate (Chemistry)</h2>
                <p className="memberTitle">Founder, Instructor, Developer</p>
                <p className="memberBio">
                <p>Delve into the world of STEM with our educational platform, where learning transcends the conventional to become a captivating and interactive experience in Science, Technology, Engineering, and Mathematics.</p>
                
                <p>The platform is spearheaded by Andrew Browne, a zealous 5th-year PhD candidate in Biochemistry. His commitment to education stems from a foundational belief that genuine understanding is nurtured through hands-on and practical learning experiences. Andrew's academic journey through the realms of biochemistry and his zest for technology have been the driving force behind our platform's goal: to spark a profound understanding and persistent curiosity in STEM among learners of all ages.</p>
                
                <p>Our platform does not just impart knowledge; it aims to ignite inspiration. Upholding the vision that the future of education is to evolve past traditional teaching methods, our platform welcomes students, educators, and the inherently curious to experience those pivotal 'eureka' moments that resonate with every learner.</p>
                </p>
            </div>
        </div>
    );
};

export default AboutUs;
